export default "__VITE_ASSET__4d42bc5d__"